import React from "react";

import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader__center">
      <div className="loadingio-spinner-double-ring-nb8my2hxaul">
        <div className="ldio-xhaaqbby8go">
          <div></div>
          <div></div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
